import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

const RightNow = () => {
  const textStyles = {
    color: 'text.primary',
    fontSize: '12px',
    padding: '2px ',
  };

  return (
    <Box sx={{ alignItems: 'center', display: 'flex' }}>
      <Typography sx={textStyles}>Right Now</Typography>
      <Tooltip arrow title="Based on loading levels for the past hour">
        <InfoIcon sx={{ color: 'gray.main' }} />
      </Tooltip>
    </Box>
  );
};

export default RightNow;
